import DefaultTaskList from '@tiptap/extension-task-list';

// This is a legacy feature in Milanote, so don't add a keyboard shortcut
export const TaskList = DefaultTaskList.extend({
    addKeyboardShortcuts() {
        return {};
    },
});
